import React from 'react';
import PropTypes from 'prop-types';
import ChargeRadioGroup from 'chargeComponents/ChargeRadioGroup';
import ChargeSelectGroup from 'chargeComponents/ChargeSelectGroup';
import ChargeCheckbox from 'chargeComponents/ChargeCheckbox';
import ChargeGroupSection from 'chargeComponents/ChargeGroupSection';
import ChargeSelect from 'chargeComponents/ChargeSelect';

class ChargeGroup extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        const { chargeGroup, chargeActions, orderId, chargeGroupSettings, orderStatus, isNoChargeDwellingType } = this.props;
        if (!chargeGroup) {
            return null;
        }

        let inputsDisabled = false,
            orderStatusItem;

        const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

        if (orderStatusList) {
            orderStatusItem = orderStatusList.first();
        }

        const sections = [];

        if (chargeGroupSettings && chargeGroupSettings.get('hidden')) {
            return null;
        }

        const groupedChargeGroups = chargeGroup
            .groupBy(item => item.get('chargeGroupRule'))
            .toList();

        groupedChargeGroups.forEach((groupedChargeGroup) => {

            const firstOfChargeGroup = groupedChargeGroup.first();

            if (firstOfChargeGroup.get('chargeGroupRule') === 'zeroOrMany') {

                const groupedDescriptions = groupedChargeGroup
                    .groupBy(item => item.get('description'))
                    .toList();

                const rows = [];

                groupedDescriptions.forEach((items, index) => {
                    if (items.count() === 1) {
                        rows.push((<ChargeSelect
                            disabled={inputsDisabled}
                            useRow={true}
                            orderId={orderId}
                            chargeActions={chargeActions}
                            key={'charge_select_' + index}
                            charge={items.first()} />));
                    } else {
                        rows.push(<ChargeSelectGroup
                            disabled={inputsDisabled}
                            useRow={false}
                            orderId={orderId}
                            chargeActions={chargeActions}
                            key={'section_child' + index}
                            groupedItems={items} />);
                    }
                });

                sections.push((
                    <ChargeGroupSection
                        title={firstOfChargeGroup.get('chargeGroup')}
                        key={'section_' + firstOfChargeGroup.get('chargeGroup')}>
                        {rows}
                    </ChargeGroupSection>
                ));

            }

            if (firstOfChargeGroup.get('chargeGroupRule') === 'zeroOrOneOf') {

                const groupedDescriptions = groupedChargeGroup
                    .groupBy(item => item.get('description'))
                    .toList();

                const zeroOrOneOfGroups = [];

                groupedDescriptions.forEach((items, index) => {
                    if (items.count() === 1) {
                        zeroOrOneOfGroups.push((<ChargeCheckbox
                            disabled={inputsDisabled}
                            orderId={orderId}
                            chargeActions={chargeActions}
                            key={'section_child' + index}
                            charge={items.first()} />));
                    } else {
                        zeroOrOneOfGroups.push((<ChargeRadioGroup
                            disabled={inputsDisabled}
                            orderId={orderId}
                            chargeActions={chargeActions}
                            key={'section_child' + index}
                            groupedItems={items} />));
                    }

                });

                if (firstOfChargeGroup.get('chargeGroup') !== 'serviceCallFee' || !isNoChargeDwellingType)
                    sections.push((
                        <ChargeGroupSection
                            title={firstOfChargeGroup.get('chargeGroup')}
                            key={'section_' + firstOfChargeGroup.get('chargeGroup')}>
                            {zeroOrOneOfGroups}
                        </ChargeGroupSection>
                    ));

            }

        });

        return (
            <div style={{
                marginTop: '10px'
            }}>

                {sections}
            </div>
        );
    }
}

ChargeGroup.propTypes = {
    orderStatus: PropTypes.object,
    chargeGroup: PropTypes.object,
    chargeActions: PropTypes.object,
    orderId: PropTypes.string,
    chargeGroupSettings: PropTypes.object,
    isNoChargeDwellingType: PropTypes.bool

};
export default ChargeGroup;



// WEBPACK FOOTER //
// ./src/components/charges/ChargeGroup.js